import { DocumentExport } from '@carbon/icons-react';
import { useTheme } from '@repo/theme';
import { FunctionalModal } from 'component/modal/functional-modal';
import { t } from 'util/stdtypes';

export function PublishSpaceModal({ onClose, onConfirm }: { onClose: () => void; onConfirm: () => void }) {
    const { colors } = useTheme();
    return (
        <FunctionalModal
            headingLabel={t('question.actions.publish_modal_heading', 'Publish this space?')}
            onClose={onClose}
            primaryButton={{
                label: t('question.actions.publish_confirm_button', 'Publish'),
                icon: <DocumentExport color={colors.colorTextOnPrimaryButton} />,
                onPress: onConfirm,
            }}
            secondaryButton={{
                label: t('modal.cancel_button', 'Cancel'),
                onPress: onClose,
            }}
            subheadingLabel={t(
                'question.actions.publish_modal_description',
                'Once published, this space will be visible to users on your production site and discoverable via SEO. Make sure your content is ready for public viewing. You can close the conversation at any time.',
            )}
        />
    );
}
